export default "__VITE_ASSET__D7KSKgJ3__"